module.exports = __webpack_public_path__ + "img/icon-016.4c2315c7.png";